import { useEffect } from "react";
import api from "@/lib/api";

function setMetaTag(attr, name, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setJsonLd(schema) {
  const existing = document.querySelectorAll('script[data-seo-schema="true"]');
  existing.forEach((el) => el.remove());
  if (!schema) return;
  const items = Array.isArray(schema) ? schema : [schema];
  items.forEach((item) => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.setAttribute("data-seo-schema", "true");
    script.textContent = JSON.stringify(item);
    document.head.appendChild(script);
  });
}

export default function SEOHead({ pageKey, schema }) {
  useEffect(() => {
    if (!pageKey) return;
    api.get(`/seo/pages/${pageKey}`).then((res) => {
      const { title, description, keywords, og_image } = res.data;
      const url = window.location.href.split("?")[0];
      if (title) document.title = title;
      setMetaTag("name", "description", description);
      setMetaTag("name", "keywords", keywords);
      setMetaTag("property", "og:type", "website");
      setMetaTag("property", "og:title", title);
      setMetaTag("property", "og:description", description);
      setMetaTag("property", "og:image", og_image);
      setMetaTag("property", "og:url", url);
      setMetaTag("name", "twitter:card", og_image ? "summary_large_image" : "summary");
      setMetaTag("name", "twitter:title", title);
      setMetaTag("name", "twitter:description", description);
      setMetaTag("name", "twitter:image", og_image);

      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", url);
    }).catch(() => {});
  }, [pageKey]);

  useEffect(() => {
    setJsonLd(schema);
    return () => setJsonLd(null);
  }, [schema]);

  return null;
}

